import React from 'react';
import { Checkbox } from 'antd';
import Item from '../Item/Item';
import HazardIndexItem from '../HazardIndexItem/HazardIndexItem';
import './Groups.scss';

const CheckboxGroup = Checkbox.Group;
const Groups = ({ item, onCheck, onGroupCheck, underwriter, selectedIndexes, save }) => {
  const list = item.children.map((item) => item.id);
  const checkedList = item.checkedChildren || [];
  const indeterminate = !!checkedList.length && checkedList.length < list.length;

  return (
    <Item
      item={item}
      extra={
        <Checkbox
          value={item.id}
          checked={item.checked}
          indeterminate={indeterminate}
          onChange={(e) => onCheck(e.target.checked, item.id)}
          disabled={item.required}
        />
      }
    >
      {!item.required && (
        <CheckboxGroup
          value={checkedList}
          onChange={(checkedList) => onGroupCheck(checkedList, item.id)}
          disabled={item.required}
        >
          <ul>
            {item.children.map((child) => {
              return <Item key={child.id} item={child} size="small" />;
            })}
          </ul>
        </CheckboxGroup>
      )}

      {underwriter && (
        <div>
          {item.children.map((child, index) => {
            const childIdStr = `${child.id}`;
            const isSelected = (selectedIndexes || []).some((id) => `${id}` === childIdStr);
            return (
              <div key={child.id} className="hazard-index-item-container appearance-row underwriter-list">
                <HazardIndexItem
                  data={child}
                  size="small"
                  appearance="row"
                  index={index}
                  underwriter
                />
                <Checkbox
                  className="check-box"
                  checked={isSelected}
                  onChange={(e) => {
                    const currentIds = (selectedIndexes || []).map(String);
                    const next = e.target.checked
                      ? [...new Set([...currentIds, childIdStr])]
                      : currentIds.filter((id) => id !== childIdStr);
                    save(next);
                  }}
                />
              </div>
            );
          })}
        </div>
      )}
    </Item>
  );
};

export default Groups;
